"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = exports.DEFAULT_TOAST_TIMEOUT_SECONDS = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_core_1 = require("@patternfly/react-core");
var react_1 = require("react");
exports.DEFAULT_TOAST_TIMEOUT_SECONDS = 5;
var ToastContext = (0, react_1.createContext)({
    addToast: function () {
        throw new Error('The `useToast` hook must be called from a descendent of the `ToastProvider`.');
    },
});
var Provider = ToastContext.Provider;
function ToastProvider(props) {
    var _a = (0, react_1.useState)([]), toasts = _a[0], setToasts = _a[1];
    var getUniqueId = function () { return new Date().getTime().toString(); };
    var addToast = function (title, variant, timeout, secondsToRemove) {
        if (variant === void 0) { variant = react_core_1.AlertVariant.default; }
        if (timeout === void 0) { timeout = true; }
        if (secondsToRemove === void 0) { secondsToRemove = exports.DEFAULT_TOAST_TIMEOUT_SECONDS; }
        var key = getUniqueId();
        setToasts(function (prevState) { return __spreadArray(__spreadArray([], prevState, true), [{ title: title, variant: variant, key: key }], false); });
        if (timeout) {
            setTimeout(function () {
                removeAlert(key);
            }, secondsToRemove * 1000);
        }
    };
    var removeAlert = function (key) {
        var newAlerts = toasts.filter(function (toast) { return toast.key !== key; });
        setToasts(newAlerts);
    };
    return ((0, jsx_runtime_1.jsxs)(Provider, __assign({ value: {
            addToast: addToast,
        } }, { children: [(0, jsx_runtime_1.jsx)(react_core_1.AlertGroup, __assign({ isToast: true, isLiveRegion: true, "data-testid": "toast-container" }, { children: toasts.map(function (_a) {
                    var variant = _a.variant, key = _a.key, title = _a.title;
                    return ((0, jsx_runtime_1.jsx)(react_core_1.Alert, { title: title, variant: variant, actionClose: (0, jsx_runtime_1.jsx)(react_core_1.AlertActionCloseButton, { title: title, variantLabel: "Close alert", onClose: function () { return removeAlert(key); } }) }, key));
                }) })), props.children] })));
}
exports.default = ToastProvider;
var useToast = function () {
    var ctx = (0, react_1.useContext)(ToastContext);
    if (!ctx) {
        throw Error('The `useToast` hook must be called from a descendent of the `ToastProvider`.');
    }
    return {
        addToast: ctx.addToast,
    };
};
exports.useToast = useToast;
